<!--Forgot Password Starts-->
<section id="forgot-password">
  <div class="row auth-height full-height-vh m-0 d-flex align-items-center justify-content-center">
    <div class="col-md-7 col-12">
      <div class="card overflow-hidden">
        <div class="card-content">
          <div class="card-body auth-img">
            <div class="row m-0">
              <div class="col-lg-6 d-none d-lg-flex justify-content-center align-items-center text-center auth-img-bg py-2">
                <img src="assets/img/GetLogo.png" alt="" class="img-fluid" width="260" height="230">
              </div>
              <div class="col-lg-6 col-md-12 px-4 py-3">
                <form [formGroup]="userForm">

                  <h4 class="mb-2 card-title">إستعادة كلمة المرور</h4>
                  <p class="card-text mb-3">الرجاء إدخال عنوان بريدك الإلكتروني وسنرسل إليك إرشادات حول كيفية إعادة
                    تعيين كلمة المرور الخاصة بك.</p>
                  <input type="email" class="form-control mb-3" placeholder="البريد الإلكتروني" formControlName="email" />
                  <div class="d-flex flex-sm-row flex-column justify-content-between">
                    <a [routerLink]="['/pages/login']" class="btn bg-light-primary mb-2 mb-sm-0">العودة للتسجيل</a>
                    <button class="btn btn-primary ml-sm-1" [disabled]="userForm.invalid" (click)="onSubmit()">إستعادة</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Forgot Password Ends-->
